import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {StorageService} from './storage.service';
import {catchError, Observable, of, tap, throwError} from 'rxjs';
import {REFRESH_KEY, RETURN_URL, USERKEY} from '../../app.config';
import {CurrentUserService} from './user.service';
import {Router} from '@angular/router';


@Injectable({
    providedIn: 'root',
})
export class AuthService {

    URL = environment.api_url;

    constructor(
        private http: HttpClient,
        private router: Router,
        private storage: StorageService,
        private userService: CurrentUserService,
        @Inject(USERKEY) private userkey: string,
        @Inject(REFRESH_KEY) private refreshKey: string,
        @Inject(RETURN_URL) private returnURL: string,
    )
    {
    }


    private getJWToken(token: string): string {
        return token.replace('Bearer ', '');
    }

    private parseJwt(token: string): object {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    login(username: string, password: string): Observable<{ token: string, refreshToken: string, user: User }> {
        return this.http.post<{
            token: string,
            refreshToken: string,
            user: User
        }>(this.URL + '/api/account/login', {username, password})
            .pipe(
                tap(({token, refreshToken, user}: { token: string, refreshToken: string, user: User }) => {
                    this.storage.setItem(this.userkey, this.getJWToken(token));
                    this.storage.setItem(this.refreshKey, this.getJWToken(refreshToken));
                    this.userService.user$.next(user);
                }),
                catchError(err => {
                    console.error(err);
                    return of(err);
                })
            );

    }

    logout(): void {
        this.storage.removeItem(this.userkey);
        this.storage.removeItem(this.refreshKey);
        this.storage.removeItem(this.returnURL);
        this.router.navigate(['/login']);
        // this.storage.removeItem(this.returnURL);
    }

    get isLoggedIn(): boolean {
        return !!this.storage.getItem(this.userkey) && !this.expired;
    }

    get token(): string | undefined | null {
        return this.storage.getItem(this.userkey);
    }

    set token(token: string) {
        this.storage.setItem(this.userkey, this.getJWToken(token));
    }

    set refreshTokenKey(val: string) {
        this.storage.setItem(this.refreshKey, this.getJWToken(val));
    }

    get expired(): boolean {
        if (!this.token) {
            return true;
        }
        const parsedToken = this.parseJwt(this.token);
        if ('exp' in parsedToken) {
            return +(parsedToken.exp as string) < Math.floor(Date.now() / 1000);
        }
        return true;
    }

    refreshToken(): Observable<{
        token: string,
        refreshToken: string,
        user: User
    }>
    {
        const accessToken: string | null | undefined = this.storage.getItem(this.userkey)
        const refreshToken: string | null | undefined = this.storage.getItem(this.refreshKey)
        if (this.router.url.includes('/restore-password')) return of()
        if (!accessToken || !refreshToken) return throwError(() => "Empty token");
        return this.http.post<{
            token: string,
            refreshToken: string,
            user: User
        }>(`${environment.api_url}/api/account/token/refresh`, {accessToken, refreshToken}, {
            withCredentials: true,
        })
    }


}
